import { InputNumber } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../../../../../../constants/forms/validation/rules'

interface RangeProps {}

const Range: FC<RangeProps> = () => {
    const name = 'range'

    return (
        <Form.Item name={name} label={'Расстояние'} rules={requiredInputNumberRules}>
            <InputNumber />
        </Form.Item>
    )
}

export default Range
